module.exports = __webpack_public_path__ + "img/pr-6.3f91a66d.png";